import { VueQueryPlugin } from '@tanstack/vue-query'
import { WagmiPlugin, http, createConfig, fallback } from '@wagmi/vue'
import { metaMask, walletConnect } from '@wagmi/vue/connectors'
import { base, mainnet } from 'viem/chains'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  const config = createConfig({
    chains: [base, mainnet],
    multiInjectedProviderDiscovery: false,
    connectors: [
      metaMask({
        name: runtimeConfig.public.siteName,
        iconUrl: '/apple-touch-icon.png'
      }),
      walletConnect({
        projectId: runtimeConfig.app.wcProjectId,
        qrModalOptions: {
          themeVariables: { '--wcm-z-index': '9999999' }
        }
      })
    ],
    syncConnectedChain: true,
    transports: {
      [base.id]: fallback([
        http(`https://base-mainnet.g.alchemy.com/v2/${runtimeConfig.app.alchemyKey}`),
        http('https://mainnet.base.org/')
      ]),
      [mainnet.id]: http('https://cloudflare-eth.com'),
    }
  })

  nuxtApp.vueApp
    .use(WagmiPlugin, { config, reconnectOnMount: false })
    .use(VueQueryPlugin, {})
})